export type OfflineExitFailureReason = 'session' | 'network' | 'sync';

/** Thrown when leaving offline mode fails; `reason` drives UI (re-auth vs retry). */
export class OfflineExitError extends Error {
  readonly reason: OfflineExitFailureReason;

  constructor(message: string, reason: OfflineExitFailureReason) {
    super(message);
    this.name = 'OfflineExitError';
    this.reason = reason;
  }
}

export function isOfflineExitError(error: unknown): error is OfflineExitError {
  return error instanceof OfflineExitError;
}
